/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const CommEmail: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5 4C3.34315 4 2 5.34315 2 7V17C2 18.6569 3.34315 20 5 20H19C20.6569 20 22 18.6569 22 17V7C22 5.34315 20.6569 4 19 4H5ZM4 7C4 6.44772 4.44772 6 5 6H19C19.5523 6 20 6.44772 20 7V17C20 17.5523 19.5523 18 19 18H5C4.44772 18 4 17.5523 4 17V7ZM7.5145 9.14251C7.04092 8.85836 6.42666 9.01192 6.14251 9.4855C5.85836 9.95908 6.01192 10.5733 6.4855 10.8575L11.4855 13.8575C11.8022 14.0475 12.1978 14.0475 12.5145 13.8575L17.5145 10.8575C17.9881 10.5733 18.1416 9.95908 17.8575 9.4855C17.5733 9.01192 16.9591 8.85836 16.4855 9.14251L12 11.8338L7.5145 9.14251Z'
      fill='currentColor'
    />
  </React.Fragment>
)
